/* eslint-disable react-hooks/exhaustive-deps */
import '../../styles/supervise.scss';
import React, { useState } from 'react';
import { NavBar, Icon, TabBar } from 'antd-mobile';
import { getBooleanValue, checkLogin } from '../../utils';
import { useHistory } from 'react-router';
import InstructionalSupervision from './instructionalSupervision';
import OnlineCourseTour from './onlineCourseTour';
import MySupervisor from './mySupervisor';

function Supervise() {
  const history = useHistory();
  const menus = [
    { key: 'instructionalSupervision', title: '教学督导' },
    { key: 'onlineCourseTour', title: '在线巡课' },
    { key: 'mySupervisor', title: '我的督导' },
  ];
  const [selectedKey, setSelectedKey] = useState(menus[0].key);
  const [selectedTitle, setSelectedTitle] = useState(menus[0].title);
  let content = null;
  switch (selectedKey) {
    case 'instructionalSupervision':
      content = <InstructionalSupervision />;
      break;
    case 'onlineCourseTour':
      content = <OnlineCourseTour />;
      break;
    case 'mySupervisor':
      content = <MySupervisor />;
      break;
    default:
      break;
  }
  return (
    <div
      className={`app-layout${getBooleanValue('IS_IMMERSE', false) ? ' immerse' : ''} supervise`}
    >
      <NavBar
        mode="light"
        icon={<Icon type="left" />}
        onLeftClick={() => history.goBack()}
        style={
          getBooleanValue('IS_IMMERSE', false)
            ? { marginBottom: '5vw', paddingTop: '6vw', height: '18vw' }
            : { marginBottom: '5vw', height: '12vw' }
        }
      >
        {selectedTitle}
      </NavBar>
      {content}
      <TabBar tabBarPosition="bottom">
        {menus.map((item) => (
          <TabBar.Item
            key={item.key}
            icon={<em className={`tabBar-icon ${item.key}`} />}
            selectedIcon={<em className={`tabBar-icon ${item.key} active`} />}
            title={item.title}
            selected={selectedKey === item.key}
            onPress={() => {
              checkLogin({
                onLogin: () => {
                  setSelectedKey(item.key);
                  setSelectedTitle(item.title);
                },
              });
            }}
          />
        ))}
      </TabBar>
    </div>
  );
}

export default Supervise;
